export const wpmToMsPerCharacter = (wpm: number) => {
  const charPerMin = wpm * 5
  const charPerSec = charPerMin / 60
  const msPerChar = 1000 / charPerSec
  return msPerChar
}
